import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { DadosUsuarioService } from 'src/app/services/dados-usuario.service';
import { CepPlacesService } from '@services/cep-places.service';
import { take } from 'rxjs/operators';
import { EnderecoFormBase } from '@pages/utils/endereco-form.base';
import { CustomErrorHandler } from '@utils/custom-error-handler';
import { LoadingGenericoComponent } from '../loading-generico/loading-generico.component';
import { SuccessGenericoComponent } from '../success-generico/success-generico.component';
import { ErrorGenericoComponent } from '../error-generico/error-generico.component';
import { EnderecoFormComponent } from '../endereco-form/endereco-form.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-alert-novo-endereco',
    templateUrl: './alert-novo-endereco.component.html',
    styleUrls: ['./alert-novo-endereco.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingGenericoComponent, SuccessGenericoComponent, ErrorGenericoComponent, EnderecoFormComponent, NgClass]
})
export class AlertNovoEnderecoComponent extends EnderecoFormBase {

  @Input() alertIncluirEndereco: boolean = false;
  @Output() alertIncluirEnderecoFechou = new EventEmitter();

  public idEmpresa: any = localStorage.idEmpresaLogada;

  constructor(
    private readonly dadosUsuarioService: DadosUsuarioService,
    formularioBuilder: UntypedFormBuilder,
    cepPlacesService: CepPlacesService,
  ) {
    super(formularioBuilder, cepPlacesService);
  }

  adicionarEndereco() {
    this.alertLoading = true;
    this.dadosUsuarioService.createNewAddress(this.idEmpresa, this.buildEnderecoPayload())
      .pipe(take(1)).subscribe({
        next: (response: any) => {
          if (response.status === 'OK') {
            this.alertLoading = false;
            this.alertSucesso = true;
            this.constroiFormulario();
          } else {
            this.alertError = true;
            this.mensagemErro = response.mensagem;
          }
        },
        error: (error: any) => {
          console.error(error);
          this.alertLoading = false;
          this.alertError = true;
          this.mensagemErro = CustomErrorHandler.extrairMensagem(error, 'Erro ao cadastrar endereço.');
        }
      });
  }

  fecharAlertSucesso(evento: string) {
    this.alertSucesso = false;
    this.fecharIncluirEndereco();
  }

  cancelarIncluirEndereco() {
    this.alertIncluirEnderecoFechou.emit('cancelar');
  }

  fecharIncluirEndereco() {
    this.alertIncluirEndereco = false;
    this.alertIncluirEnderecoFechou.emit(this.alertIncluirEndereco);
  }
}
